module.exports = __webpack_public_path__ + "static/media/maestro.17d8dded.svg";